/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ReviewerScorecardTimeseriesEntity } from './ReviewerScorecardTimeseriesEntity.js';
import {
    ReviewerScorecardTimeseriesEntityFromJSON,
    ReviewerScorecardTimeseriesEntityFromJSONTyped,
    ReviewerScorecardTimeseriesEntityToJSON,
} from './ReviewerScorecardTimeseriesEntity.js';

/**
 * 
 * @export
 * @interface ReviewerScorecardStats
 */
export interface ReviewerScorecardStats {
    /**
     * 
     * @type {Array<ReviewerScorecardTimeseriesEntity>}
     * @memberof ReviewerScorecardStats
     */
    timeseries?: Array<ReviewerScorecardTimeseriesEntity>;
}

/**
 * Check if a given object implements the ReviewerScorecardStats interface.
 */
export function instanceOfReviewerScorecardStats(value: object): boolean {
    return true;
}

export function ReviewerScorecardStatsFromJSON(json: any): ReviewerScorecardStats {
    return ReviewerScorecardStatsFromJSONTyped(json, false);
}

export function ReviewerScorecardStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewerScorecardStats {
    if (json == null) {
        return json;
    }
    return {
        
        'timeseries': json['timeseries'] == null ? undefined : ((json['timeseries'] as Array<any>).map(ReviewerScorecardTimeseriesEntityFromJSON)),
    };
}

export function ReviewerScorecardStatsToJSON(value?: ReviewerScorecardStats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timeseries': value['timeseries'] == null ? undefined : ((value['timeseries'] as Array<any>).map(ReviewerScorecardTimeseriesEntityToJSON)),
    };
}

